<template>
  <section id="cta" class="py-16 bg-blue-600 text-white text-center">
    <div class="max-w-4xl mx-auto px-6">
      <h2 class="text-3xl font-bold leading-tight">
        🚀 Pronto para aumentar suas vendas com Google Ads?
      </h2>
      <p class="mt-4 text-lg">
        Tenha mais leads, mais clientes e mais faturamento com uma estratégia profissional.
      </p>

      <!-- Botão principal -->
      <div class="mt-6">
        <a
          href="https://wa.me/+5519999041297" target="_blank"
          class="bg-white text-blue-600 px-8 py-4 rounded-lg shadow-lg text-lg font-bold hover:bg-gray-200 transition"
        >
          💬 Fale com um Especialista
        </a>
      </div>

      <!-- Garantia ou Prova Social -->
      <div class="mt-8 text-sm opacity-90">
        <p>📞 Atendimento rápido e sem compromisso.</p>
        <p>✅ Garantimos uma análise gratuita do seu negócio!</p>
      </div>
    </div>
  </section>
</template>
